module.exports = __webpack_public_path__ + "img/watch-square.354515a0.svg";